var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visit-page pb-3"},[_c('div',{staticClass:"container"},_vm._l((_vm.education),function(item,id){return _c('TheEventList',{key:id,attrs:{"education":item,"education-key":id}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }